import clsx from 'clsx';

type Props = React.HTMLAttributes<HTMLDListElement> & {
  children: React.ReactNode;
};
export function DescriptionList({
  className,
  children,
  ...props
}: Props): React.JSX.Element {
  return (
    <dl {...props} className={clsx('divide-y divide-slate6', className)}>
      {children}
    </dl>
  );
}

DescriptionList.displayName = 'DescriptionList';
